(function (window) {
  function getFlavorInputs(container, inputSelector) {
    return Array.prototype.slice.call(container.querySelectorAll(inputSelector));
  }

  function buildFlavorProperties(inputs, getValue, getLabel) {
    var properties = {};
    var count = 0;

    inputs.forEach(function (input) {
      var qty = parseInt(getValue(input), 10) || 0;
      if (qty <= 0) return;

      count += 1;
      properties["Flavor " + count] = qty + " x " + getLabel(input);
    });

    return properties;
  }

  function addPackToCart(options) {
    var item = {
      id: options.variantId,
      quantity: options.quantity || 1,
      properties: options.properties || {},
    };

    if (options.sellingPlanId) {
      item.selling_plan = options.sellingPlanId;
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [item] }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || "Could not add to cart");
        }
        return data;
      });
    });
  }

  function findSellingPlanId(plans, matchText) {
    if (!plans || !plans.length || !matchText) return "";

    var needle = matchText.toLowerCase();

    for (var i = 0; i < plans.length; i++) {
      var plan = plans[i];
      if (plan.name && plan.name.toLowerCase().indexOf(needle) !== -1) {
        return String(plan.id);
      }
    }

    return "";
  }

  window.HappyJoBoxCart = {
    getFlavorInputs: getFlavorInputs,
    buildFlavorProperties: buildFlavorProperties,
    addPackToCart: addPackToCart,
    findSellingPlanId: findSellingPlanId,
  };
})(window);
